<template>
  <li
    :class="{active: active || hovered}"
    class="request-list__request"
    @mouseover="hovered = true"
    @focus="hovered = true"
    @mouseleave="hovered = false"
    @blur="hovered = false"
  >
    <a
      href="#"
      @click.prevent="$emit('activate')"
    >
      <span v-if="request.dealer_name">
        <span
          class="dealer-name"
          v-text="request.dealer_name"
        />
        <br>
      </span>

      <span v-text="request.name" />
    </a>
  </li>
</template>

<script>
import DocumentRequestModel from '../../../../models/documentRequest';

export default {
  props: {
    request: {
      type: DocumentRequestModel,
      default: null,
    },

    active: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      hovered: false,
    };
  },
};

</script>
<style lang="scss" scoped>
    .request-list__request {
        .dealer-name {
            font-size: 0.75em;
        }
    }
</style>
